/* eslint-disable max-params */
import {
  IEventType,
  IEvent,
  IModalDialogOptions,
  WIDGET_COMPONENT,
  ENTITY_TYPES,
} from '../../types';
import { map, merge } from 'lodash';
import { BTN_CANCEL, BTN_DONE } from '@text-content/button-templates';
import { Observable } from 'rxjs';
import { WIDGET_FAMILY, EVENT_SELECTOR_SELECT } from '@config/global-constants';
import { DataSource } from '../datasource';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

const selectSiteAndEventModal = (options: {
  sitesList: DataSource;
  eventTypeList: IEventType[];
  eventList: IEvent[];
  disabledObs: Observable<boolean>;
  disabledEventIdObs: Observable<boolean>;

  i18nService: XVII18nService;
}): IModalDialogOptions => {
  const {
    sitesList,
    eventTypeList,
    eventList,
    disabledObs,
    disabledEventIdObs,
    i18nService,
  } = options;

  return merge(
    {},
    {
      showLoader: true,
      title: I18n.Common.SelectSiteAndEvent,
      validation: true,
      modalClass: `modal-md`,
      buttons: [
        {
          ...BTN_DONE,
          disabledObs,
          caption: I18n.Common.Submit,
        },
        BTN_CANCEL,
      ],
      value: {
        event_type_id: '',
        site_id: '',
        event_ids: [],
        url: '',
      },
      schema: {
        type: 'object',
        properties: {
          site_id: {
            type: 'object',
          },
          event_type_id: {
            type: 'string',
          },
          event_ids: {
            type: 'array',
          },
          url: {
            type: 'string',
          },
        },
      },
      formRules: {
        fields: {
          site_id: {
            title: I18n.EntityNames.Site,
            widget: WIDGET_COMPONENT.entity_select,
            widgetFamily: WIDGET_FAMILY.XUX,
            required: true,
            widgetData: {
              placeholder: i18nService.translate(I18n.Sites.Pleaseselectasite),
              entity: ENTITY_TYPES.SITE,
              dataSource: sitesList,
              lazy: true,
              enableClientFiltering: true,
            },
          },
          event_type_id: {
            title: I18n.EntityNames.EventType,
            widget: WIDGET_COMPONENT.select,
            widgetFamily: WIDGET_FAMILY.XUX,
            required: true,
            selectOptions: map(eventTypeList, (item: IEventType) => ({
              text: item.name,
              value: item.entity_id,
            })),
            widgetData: {
              placeholder: i18nService.translate(
                I18n.InfoMessages.PleaseSelectEventType,
              ),
            },
          },
          event_ids: {
            title: I18n.Forms.TransferForm.HistoricalEvent,
            widgetFamily: WIDGET_FAMILY.XUX,
            required: true,
            selectOptions: map(eventList, (item: IEvent) => ({
              text: item.name,
              value: item.id,
            })),
            disabledObs: disabledEventIdObs,
            widgetData: {
              placeholder: i18nService.translate(
                I18n.InfoMessages.PleaseSelectEvent,
              ),
              availableEventStatus: ['closed'],
              sortForPortalSelector: ['event_days/start_date_time desc'],
              isMultiple: true,
              maxItems: 5,
              minItems: 1,
              useInputUrl: true,
              select: EVENT_SELECTOR_SELECT,
            },
            widget: WIDGET_COMPONENT.select_event_with_grid_modal,
          },
          url: {
            show: false,
          },
        },
      },
    },
  );
};

export const historicalModalDefinition = {
  selectSiteAndEventModal,
};
